import { Stack, Text } from "@chakra-ui/react";

import { getAppVersion } from "../../utils";
import { PageHeader } from "../../components/shared/PageHeader";
import { ProfilePageContent } from "../../components/features/Profile/ProfilePage";

export function ProfilePage() {
  return (
    <Stack id="profilePage" minH="100svh" px="4px" pb="20px" spacing={0}>
      <PageHeader title="Профиль" />

      <ProfilePageContent />

      <Text
        fontSize="14px"
        textAlign="center"
        mt="10px"
      >
        {getAppVersion()}
      </Text>
    </Stack>
  );
}
